jQuery(function ($) {
    var device = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    $(window).on('resize', function () {
        calculateSimpleCalendarHeight();
        responsive();
    }).trigger('resize');

    $(document).ready(function (e) {
        if ($('[data-rel="simplecalendar"]').length) {
            //Set active datepicker
            setActiveDate(moment().format('YYYY-MM-DD'), true);

            getCalendar();

            $('#my-datepicker .table-condensed th.prev').html('<img src="'+window.DOMAIN+'images/arrow-left.svg" />');
            $('#my-datepicker .table-condensed th.next').html('<img src="'+window.DOMAIN+'images/arrow-right.svg" />');

            //Refresh calendar after 5 minutes
            setInterval(function() {
                getCalendar();
            }, 600000);
        }

        /**
         * Goto calendar
         */
        $(document).on('click', '[data-rel="go-to-next-available"]', function(e) {
            e.preventDefault();

            // var date = moment().format('YYYY-MM-DD');
            var date = $(this).data('date');
            $('[data-rel="simplecalendar"]').attr('data-start-date', date);

            setActiveDate(date, true);

            getCalendar();
        });

        //Show small calendar mobile
        var device = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (device < 1025) {
            $(document).on('click', '.simplecalendar-title', function(e) {
               $("#my-datepicker").toggle();
            });

            $('#my-datepicker').datepicker().on('changeDate', function (ev) {
                $("#my-datepicker").hide();
            });
        }
    });

    $('.dropdown-submenu > a').on("click", function(e){
        e.stopPropagation();
        e.preventDefault();
        $(this).next('ul').show();
    });

    $("#my-datepicker").datepicker({
        weekStart: 1,
        language: $("#locale").val()
        // language: "nl"
        // startDate: new Date()
        // todayBtn: "linked",
        // todayHighlight: true
    }).on('changeDate', function (e) {
        var date = moment(e.format('mm/dd/yyyy')).format('YYYY-MM-DD');

        $('[data-rel="simplecalendar"]').attr('data-start-date', date);

        //Set active datepicker
        setActiveDate(date, true);

        //Refresh calendar
        getCalendar(date);
    });

    function calculateSimpleCalendarHeight() {
        // Resize to biggest calendar max height is 425 (only when window is bigger then 760px)
        if($('body').width() < 760) {
            $('.component-calendar-widget-content').css({'height': 'auto'});
        }
        // Groupoverview calculation
        else if($('.component-calendar-widget-content').length > 1) {
            var maxHeightCalendarWidgetContent = 30;

            $('.component-calendar-element').each(function(index, item) {

                // Define needed elements
                var currentHeight = 0,
                    simpleCalendarElement = $(item).find('.component-calendar-widget-content .simplecalendar'),
                    textHouseElement = $(item).find('.component-calendar-text-wrapper');

                // Add calendar height
                if(simpleCalendarElement.length > 0) {
                    currentHeight += simpleCalendarElement.height();
                }

                // Add text height
                if(textHouseElement.length > 0) {
                    currentHeight += textHouseElement.height();
                }

                // Is it bigger then the current defined height?
                if(currentHeight > maxHeightCalendarWidgetContent) {
                    maxHeightCalendarWidgetContent = currentHeight;
                }
            });

            if((maxHeightCalendarWidgetContent + 1) > 425) {
                maxHeightCalendarWidgetContent = 425;
            }

            maxHeightCalendarWidgetContent = maxHeightCalendarWidgetContent;

            $('.component-calendar-element').each(function(index, item) {
                var elementMaxHeightCalendarWidgetContent = maxHeightCalendarWidgetContent,
                    textHouseElement = $(item).find('.component-calendar-text-wrapper');

                // Correction not all elements will have this height
                if(textHouseElement.length > 0) {
                    elementMaxHeightCalendarWidgetContent = elementMaxHeightCalendarWidgetContent - textHouseElement.height();
                }

                $(item).find('.component-calendar-widget-content').css({'height': (elementMaxHeightCalendarWidgetContent + 95) + 'px'});
            });
        }

        // Recalculate scroll bar
        var simpleBarElements = $('.component-calendar-widget-content[data-simplebar]');
        if(simpleBarElements.length > 0) {
            $.each(simpleBarElements, function (key, value) {
                var el = new SimpleBar(value, {
                    autoHide: false
                });
                el.recalculate();
            });
        }
    }

    function responsive() {
        if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768) {
            var currentView = $('[data-rel="simplecalendar"]').attr('data-view');

            if(currentView == 'week') {
                $('[data-rel="simplecalendar-view-switch"][data-view="week"]').addClass('disabled');

                $('[data-rel="simplecalendar-view-switch"]').removeClass('active');
                $('[data-rel="simplecalendar-view-switch"][data-view="day"]').addClass('active');

                $('[data-rel="simplecalendar"]').attr('data-view', 'day');

                //Refresh calendar
                getCalendar();
            }
        }
        else {
            $('[data-rel="simplecalendar-view-switch"][data-view="week"]').removeClass('disabled');
        }

        calculateSimpleCalendarHeight();
    }

    function getCalendar(date, view, callback) {
        //loading title
        $('.simplecalendar-title').html('<i class="fa fa-spinner fa-pulse font-size-18"></i>');

        var _callback = (typeof callback === 'function') ? callback : false;

        $('body').loading('toggle');
        $('[data-rel="simplecalendar"]').each(function(index) {
            var agendaHolder = $(this),
                ajaxUrl = $(agendaHolder).attr('data-date-url'),
                agendaId = $(agendaHolder).attr('data-agenda-id'),
                _date = (typeof date === 'undefined' || date === null) ? $(agendaHolder).attr('data-start-date') : date,
                _view = (typeof view === 'undefined' || view === null) ? $(agendaHolder).attr('data-view') : view;

            if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768) {
                _view = 'day';

                $('[data-rel="simplecalendar"]').attr('data-view', 'day');
                $('[data-rel="simplecalendar-view-switch"]').removeClass('active');
                $('[data-rel="simplecalendar-view-switch"][data-view="day"]').addClass("active");
            }

            var types = false,
                listTypes = $(agendaHolder).attr('data-types'),
                amounts = false,
                listAmounts = $(agendaHolder).attr('data-amounts');

            if(typeof listTypes != 'undefined') {
                types = listTypes.split(',');
            }
            if(typeof listAmounts != 'undefined') {
                amounts = listAmounts.split(',');
            }

            $.ajax({
                url: ajaxUrl,
                data: {
                    agendaId: agendaId,
                    date: _date,
                    view: _view,
                    types: types,
                    amounts: amounts
                }
            }).done(function(data) {
                if (data.status == 200) {
                    $('[data-rel="simplecalendar-title"]').html(data.title);
                    $('[data-rel="simplecalendar-prev-date"]').attr('simple-date', data.prevDate);
                    $('[data-rel="simplecalendar-next-date"]').attr('simple-date', data.nextDate);
                    $(agendaHolder).html(data.html);

                    calculateSimpleCalendarHeight();

                    if ((parseInt(index) + parseInt(1)) == $('[data-rel="simplecalendar"]').length) {
                        $('body').loading('toggle');
                    }

                    if(typeof _callback === 'function') {
                        var callbackResult = callback(index);

                        // Break loop
                        if(callbackResult === false) {
                            return false;
                        }
                    }
                }
            }).fail(function (jqXHR, textStatus) {
                $('body').loading('toggle');
            });
        });
    }

    function setActiveDate(date, active) {
        var _date = Date.parse(date);
        var currentView = $('[data-rel="simplecalendar"]').attr('data-view');
        var calendar = $('[data-rel="simplecalendar"]').attr('data-calendar');

        $('#my-datepicker .table-condensed td').each(function(k, selector) {
            $(selector).removeClass('active-day');

            if ($(selector).data('date') === parseInt(_date)) {
                if (currentView != 'day'/* || calendar == 'group'*/) {
                    $('#my-datepicker .row-active').removeClass('row-active');
                    $('#my-datepicker .active').removeClass('active');
                    $(selector).parent().addClass('row-active');
                }

                if (Date.parse(moment().format('YYYY-MM-DD')) == $(selector).data('date')) {
                    $(selector).addClass('active');
                } else if ((active && currentView == 'day'/* && calendar != 'group'*/)){
                    $(selector).removeClass('active').addClass('active-day');
                } else {
                    $(selector).removeClass('active');
                }
            }
        });
    }

    $('[data-rel="simplecalendar-prev-date"],[data-rel="simplecalendar-next-date"]').click(function(e) {
        e.preventDefault();
        if ($(this).attr('simple-date')) {
            var date = $(this).attr('simple-date');
            $('[data-rel="simplecalendar"]').attr('data-start-date', date);

            $('#my-datepicker').datepicker("setDate", new Date(date));

            // setActiveDate(date, false);
        }
    });

    $(document).on('click', '[data-rel="simplecalendar-today-date"]', function (e) {
        e.preventDefault();
        if ($(this).attr('simple-date')) {
            $('[data-rel="simplecalendar"]').attr('data-start-date', $(this).attr('simple-date'));

            $('#my-datepicker').datepicker("setDate", new Date(moment().format('YYYY-MM-DD')));

            setActiveDate(moment().format('YYYY-MM-DD'), true);
        }
    });

    $(document).on('click', '[data-rel="simplecalendar-view-switch"]', function (e) {
        e.preventDefault();
        if ($(this).attr('data-view')) {
            $('[data-rel="simplecalendar-view-switch"]').removeClass('active');
            $(this).addClass("active");
            $('[data-rel="simplecalendar"]').attr('data-view', $(this).attr('data-view'));

            $('#my-datepicker').datepicker("setDate", new Date($('[data-rel="simplecalendar"]').attr('data-start-date')));
        }
    });

    $('#chooseTypeAppointment a').click(function(e) {
        var id = $(this).data('id');
        var agendaId = $(this).data('agenda-id');

        $('#showTextForPatient').show().removeClass('show');
        $('#showTextForPatient .parentText').hide();
        $('#calendar-view #list-agenda-name .name').hide();

        $('#showTextForPatient .textForPatient' + id).show();
        $('#showTextForPatient .block' + id).show();
        $('#calendar-view #list-agenda-name .name' + agendaId).show();

        // $('#calendar-view .component-calendar-widget')
        //     .attr('id', 'calendar_' + agendaId)
        //     .attr('data-agenda-id', agendaId);

        $('#chooseTypeAppointment a').removeClass('check');

        if ($(this).hasClass('check')) {
            $(this).removeClass('check');
        } else {
            $(this).addClass('check');
        }

        $('[data-rel="simplecalendar"]').attr('data-types', getListType());
        getCalendar();
    });

    $('#showTextForPatient a.fa').click(function() {
        var container = $(this).closest('#showTextForPatient');
        if (container.hasClass('show')) {
            container.removeClass('show');
            $(this).removeClass('fa-minus').addClass('fa-plus');
        } else {
            container.addClass('show');
            $(this).removeClass('fa-plus').addClass('fa-minus');
        }
    });

    function getListType() {
        var id;
        $('#chooseTypeAppointment a').each(function(k, v) {
            if ($(this).hasClass('check')) {
                id = $(this).data('id');
            }
        });
        return id;
    }

    $(window).trigger('resize');

    $(document).ready(function () {
        $(document).on('click', '.slot-item', function (e) {
            e.preventDefault();
            var $this = $(this);
            $this.toggleClass('added');

            var $url = $this.data('url');
            var $slotAdded = $('.slot-item.added');

            var queryString = [];
            var total = 0;
            $slotAdded.each(function (i, el) {
                var $slot = $(el).data('slot');
                var end = $slot.end.split(' ')[0]
                queryString.push(`slot[${$slot.slotID}]=${encodeURIComponent(end)}`);

                total += $slot.price;
            });

            $url += $url.includes('?') ? '&' : '?';
            $url += queryString.join('&');

            var $component = $('.component-calendar-cart');
            var $button = $('.booking-appointment');
            var $added = $('.count-added');
            var $total = $('.total-price');

            var callback = $this.data('callback');
            if(callback) {
                $url += '&callback=' + callback;
            }

            if ($slotAdded.length) {
                $added.html($slotAdded.length);
                $total.html(total.toLocaleString('de-DE', { maximumFractionDigits: 0 }));
                $button.attr('href', $url);
                $component.removeClass('hidden');
            } else {
                $added.html(0);
                $total.html(0);
                $button.attr('href', '#');
                $component.addClass('hidden');
            }
        }).on('click', '.remove-slot', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $slots = $('#slots');
            var id = $this.data('id');
            var $total = $('body .show-total');
            var slots = $slots.val();
            slots = JSON.parse(slots);

            if (slots.hasOwnProperty(id)) {
                delete slots[id];
                $slots.val(JSON.stringify(slots));
                setTotalPrice($total);

                var queryString = [];

                for (var id in slots) {
                    if (slots.hasOwnProperty(id)) {
                        var date = slots[id];
                        queryString.push(`slot[${id}]=${encodeURIComponent(date)}`);
                    }
                }

                var date = $this.data('date');
                var slotId = $this.data('slot_id');
                var subdivisionId = $this.data('subdivision_id');

                if (queryString.length) {
                    var url = window.location.pathname + '?' + queryString.join('&');
                    if(date) {
                        url += '&date=' + date;
                    }
                    if(slotId) {
                        url += '&slot_id=' + slotId;
                    }
                    if(subdivisionId) {
                        url += '&subdivision_id=' + subdivisionId;
                    }
                    window.location.href = url;
                } else {
                    window.location.href = window.location.pathname;
                }
            }
        });

    });

    function setTotalPrice($el) {
        var $remaining = $('.remaining-slot');

        if ($remaining.length === 1) {
            $('.td-action').remove();
        }

        var total = 0;
        $remaining.each(function (i, item) {
            var price = $(item).data('price');
            total += price;
        });

        $el.attr('data-total', total);
        $el.html(total.toLocaleString('de-DE', { maximumFractionDigits: 0 }));
    }
});
